import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { toastHandler } from "@/lib/ToastHandler";
import { initOrdersRealtime, cleanupOrdersRealtime } from "./orders-realtime";

export default function OrdersLayout() {
  useEffect(() => {
    initOrdersRealtime();

    const onOpen = () =>
      toastHandler({
        title: "Conectado a tiempo real",
        description: "Recibirás actualizaciones de órdenes al instante.",
        variant: "default",
      });
    const onClose = () =>
      toastHandler({
        title: "Desconectado de tiempo real",
        description: "Intentando reconectar...",
        variant: "destructive",
      });

    window.addEventListener("orders-realtime:open", onOpen as EventListener);
    window.addEventListener("orders-realtime:close", onClose as EventListener);

    return () => {
      window.removeEventListener(
        "orders-realtime:open",
        onOpen as EventListener,
      );
      window.removeEventListener(
        "orders-realtime:close",
        onClose as EventListener,
      );
      cleanupOrdersRealtime();
    };
  }, []);

  return <Outlet />;
}
